/* FD brand ---------------------------------------------------------------
   Furniture Done bottom bar + slide-over trays.

   The mock drives this with hidden checkboxes because it must run without
   JavaScript under a strict CSP. Its own comment says the real theme should use
   buttons plus JS, which is what this is: it is what makes the focus trap,
   Escape handling and correct aria state possible.

   With JS off the bar still renders and its link buttons (Search, Basket)
   still work; only the tray stays shut. Navigation is not lost — the top-level
   menu items are reachable from the desktop row above 820px and from the
   footer menus below it.
   ------------------------------------------------------------------------ */
(function () {
  'use strict';

  var root = document.querySelector('.fd-bnav');
  if (!root) return;

  /* The whole snippet is header markup, so a shopify:section:load in the
     theme editor replaces .fd-bnav wholesale and re-runs this file with it.
     A FRESH root carries no marker and gets a fresh set of listeners, which is
     right; re-running against a root that already has one would double-bind
     everything, the document-level keydown trap included. */
  if (root.hasAttribute('data-fd-bnav-init')) return;
  root.setAttribute('data-fd-bnav-init', '');

  /* ---- the basket slot ----
     The basket moved out of the top bar and into the pill (user, 2026-09-05),
     so this slot has to do everything Dawn's header icon did.

     COUNT: mirrored, never recomputed. Every cart mutation in Dawn re-renders
     the `cart-icon-bubble` section into #cart-icon-bubble, so watching that
     element is the one hook that cannot disagree with the real basket -- the
     same idiom the buy bar uses on the price block. The anchor is still in the
     DOM below 821px, only display:none, precisely so this keeps working.

     DRAWER: with a cart drawer enabled, cart-drawer.js binds the drawer to
     that same hidden anchor. Forwarding the tap keeps the pill's basket
     behaving like the site's basket instead of navigating away. With JS off,
     or with no drawer, the slot is a plain link to /cart -- the no-JS floor. */
  var cartSource = document.getElementById('cart-icon-bubble');
  var cartSlot = root.querySelector('[data-fd-cart-slot]');

  if (cartSlot && cartSource) {
    var badge = cartSlot.querySelector('[data-fd-cart-badge]');
    var countText = cartSlot.querySelector('[data-fd-cart-count-text]');

    var syncCount = function () {
      var bubble = cartSource.querySelector('.cart-count-bubble');
      /* Dawn drops the bubble entirely for an empty basket, and prints no
         digits at all past 99 -- both mean "no number to show here". */
      var digits = bubble ? (bubble.querySelector('[aria-hidden="true"]') || {}).textContent : '';
      digits = (digits || '').trim();
      if (badge) {
        badge.textContent = digits;
        badge.hidden = digits === '';
      }
      if (countText) {
        var spoken = bubble ? bubble.querySelector('.visually-hidden') : null;
        countText.textContent = spoken ? spoken.textContent.trim() : '';
      }
    };

    new MutationObserver(syncCount).observe(cartSource, { childList: true, subtree: true, characterData: true });
    syncCount();

    cartSlot.addEventListener('click', function (event) {
      var drawer = document.querySelector('cart-drawer');
      /* cart-drawer.liquid ships even when the cart is empty, where Dawn marks
         it .is-empty and the drawer still opens with its empty state -- but a
         drawer that never got upgraded (JS error, editor) must fall through to
         the link rather than swallow the tap. */
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open(cartSlot);
    });
  }


  var tray = root.querySelector('[data-fd-tray-root]');
  var scrim = root.querySelector('[data-fd-bnav-scrim]');
  var toggle = root.querySelector('[data-fd-tray-toggle]');
  var backBtn = root.querySelector('[data-fd-back]');
  var panels = root.querySelectorAll('[data-fd-tray]');
  var labelOpen = root.querySelector('[data-fd-label-open]');
  var labelClose = root.querySelector('[data-fd-label-close]');
  var bar = root.querySelector('.fd-bbar');
  var ind = root.querySelector('[data-fd-ind]');
  var indHide = null;
  if (!tray || !toggle) return;

  /* ---- the search slot ----
     Forwards to Dawn's predictive-search modal in the header rather than
     leaving the page (user, real-device 2026-09-06). DetailsModal.open() reads
     event.target.closest('details'), so the clean hook is the summary's own
     click -- its onSummaryClick preventDefaults and opens, and every scrap of
     search behaviour, results rendering and focus handling stays Dawn's. If the
     header renders no modal (a layout without it, or the element never
     upgraded) the tap falls through to the link and lands on /search -- the
     no-JS floor, kept. Bound AFTER the tray guard above so close() can never
     run against an undefined tray on a page that has no tray.

     While the modal is open the slot is its CLOSE control (user, 2026-09-06:
     "can't the search button turn into a back button so users don't need to
     stretch to the top"), the same deal the menu slot has with the tray. The
     slot's state is never derived from the tap: it is read off the modal's own
     <details open> attribute through a MutationObserver, so Escape, an outside
     tap and Dawn's own close button revert the slot exactly like a second tap
     does. If the header renders no modal, none of this arms and the slot stays
     the plain /search link. */
  var searchSlot = root.querySelector('[data-fd-search-open]');
  var searchLabelOpen = searchSlot ? searchSlot.querySelector('[data-fd-search-label-open]') : null;
  var searchLabelClose = searchSlot ? searchSlot.querySelector('[data-fd-search-label-close]') : null;
  var searchModalRoot = null;
  var searchDetails = null;
  var searchObs = null;
  var searchWasOpen = false;
  /* Set only while open() is closing the modal to hand the surface to the tray:
     the focus return below must not fire then, because the tray owns focus from
     that point on. */
  var searchYield = false;

  /* Dawn can render TWO details-modal.header__search in one layout -- the
     top-centre header puts one in its own row (sections/header.liquid:134) and
     the default layout renders another (:262) -- and only one of them is laid
     out. A bare querySelector takes whichever comes first in the DOM, which on
     the top-centre layout is the hidden one: its <details open> would never
     move, so the slot would never wear its X and a second tap would never
     close anything. Prefer the rendered instance (computed display not none),
     fall back to the first so a modal that is merely off-screen still binds. */
  function searchModal() {
    var all = document.querySelectorAll('details-modal.header__search');
    if (!all.length) return null;
    for (var i = 0; i < all.length; i++) {
      var style = window.getComputedStyle(all[i]);
      if (style && style.display !== 'none') return all[i];
    }
    return all[0];
  }

  function searchOpen() {
    return !!(searchDetails && searchDetails.hasAttribute('open'));
  }

  /* One place decides what the slot looks like and says, called from the
     observer rather than from the tap. */
  function syncSearchState() {
    var now = searchOpen();
    root.classList.toggle('is-search-open', now);
    if (searchSlot) searchSlot.setAttribute('aria-expanded', now ? 'true' : 'false');
    if (searchLabelOpen) searchLabelOpen.hidden = now;
    if (searchLabelClose) searchLabelClose.hidden = !now;
    if (now === searchWasOpen) return;
    /* One-shot: consumed on the first transition after open() yielded. */
    var yielding = searchYield;
    searchYield = false;
    /* Closing returns focus somewhere real. Dawn's close(true) aims focus at
       its own summary, which is display:none below 821px, so focus lands on
       <body>; only then -- never when the shopper has already put focus
       somewhere themselves, and never when the tray is taking the surface
       over -- is it pulled back to the slot they tapped. */
    if (
      searchWasOpen &&
      !now &&
      !yielding &&
      (!document.activeElement || document.activeElement === document.body)
    ) {
      focusSafely([searchSlot]);
    }
    searchWasOpen = now;
    /* The lit slot follows: activeSlot() reads the same flag, so the indicator
       slides onto the search slot while the modal is up and back off it when
       it closes. */
    syncIndicator(true);
  }

  /* The modal and the pill are both header markup, so a shopify:section:load
     replaces the pair. Re-resolving is idempotent: an unchanged element is a
     no-op, a replaced one gets a fresh observer and the stale one is dropped. */
  function bindSearchModal() {
    if (!searchSlot) return;
    var modal = searchModal();
    var details = modal ? modal.querySelector('details') : null;
    /* Cached so the tap acts on the SAME instance the observer is watching:
       resolving twice could pick two different modals if the layout changed in
       between, and then the X and the thing it closes would disagree. */
    searchModalRoot = modal;
    if (details === searchDetails) return;
    if (searchObs) {
      searchObs.disconnect();
      searchObs = null;
    }
    searchDetails = details;
    if (searchDetails) {
      searchObs = new MutationObserver(syncSearchState);
      searchObs.observe(searchDetails, { attributes: true, attributeFilter: ['open'] });
    }
    syncSearchState();
  }

  if (searchSlot) {
    bindSearchModal();

    document.addEventListener('shopify:section:load', function () {
      /* A replaced root re-runs this file from the top, so a stale instance
         has nothing left to keep in sync. */
      if (!root.isConnected) return;
      bindSearchModal();
    });

    searchSlot.addEventListener('click', function (event) {
      bindSearchModal();
      var modal = searchModalRoot;
      var summary = modal ? modal.querySelector('summary') : null;
      if (!modal || !summary || typeof modal.open !== 'function') return;
      event.preventDefault();

      if (searchOpen()) {
        /* close(false), not close(): close(true) hands focus to the summary,
           which is display:none here, so focus would be dropped on the floor.
           We put it back on the slot ourselves (via the observer's own
           transition handling above). This also runs BEFORE Dawn's own
           body-click dismiss listener -- same tap, later in the bubble path --
           and unregisters it, so the close happens exactly once. */
        modal.close(false);
        return;
      }

      /* The tray is a modal sheet with its own focus trap; leaving it open
         behind the search modal would fight it for focus. */
      if (isOpen()) close();
      /* Deferred by a tick, and that is load-bearing. DetailsModal.open()
         registers its own click listener on document.body to dismiss on an
         outside tap; forwarding synchronously would register it while THIS
         click is still bubbling, so the same tap would reach body, count as
         "outside the modal" (the pill is not inside it) and shut the modal in
         the same gesture that opened it. */
      setTimeout(function () {
        summary.click();
      }, 0);
    });
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])';
  var lastFocus = null;
  var lastDrill = null;

  /* A descendant combinator binds tighter than the commas in a selector list,
     so 'SCOPE a[href], button, ...' scopes only the FIRST alternative and lets
     the rest match document-wide. Every alternative has to carry the prefix. */
  function scopedFocusable(prefix) {
    return FOCUSABLE.split(',')
      .map(function (part) {
        return prefix + ' ' + part.trim();
      })
      .join(', ');
  }

  /* Focus must never be dropped on <body>: hiding a panel or the whole tray
     while it holds focus does exactly that, so every path that hides something
     hands focus somewhere deliberate. */
  function focusSafely(candidates) {
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el && el !== document.body && el.isConnected && el.offsetParent !== null) {
        el.focus();
        return true;
      }
    }
    return false;
  }

  function showPanel(key) {
    panels.forEach(function (panel) {
      var on = panel.dataset.fdTray === key;
      panel.classList.toggle('is-on', on);
      if (panel.dataset.fdTray !== 'root') panel.hidden = !on;
    });
    var drilled = key !== 'root';
    tray.classList.toggle('is-drilled', drilled);
    if (backBtn) backBtn.hidden = !drilled;
    /* Showing or hiding the Back slot changes every slot's width, so the
       indicator has to be re-measured -- but it must not TRAVEL: the Back slot
       stands exactly where the menu slot was, so the highlight has not moved,
       only the maths behind it. Gated on the tray actually being open because
       open() and close() both call showPanel() while .is-open is out of step
       with where the indicator is going, and they own the animated call. */
    if (isOpen()) syncIndicator(false);
  }

  function open() {
    /* The pill has exactly one open sheet at a time. The search slot already
       closes the tray on its way in; this is the same rule in the other
       direction, and it sits at the top of open() rather than in the toggle's
       click handler so EVERY path that opens the tray is covered (the toggle,
       and shopify:block:select in the theme editor). Without it the two
       surfaces stack: two focus traps run at once (ours, gated on isOpen(),
       and Dawn's), .is-search-open is never cleared, and activeSlot() -- which
       tests isOpen() before searchOpen() -- lights the menu slot while the CSS
       still lights the search slot, so the pill shows two answers to "where am
       I". close(false), not close(): close(true) aims focus at the summary,
       which is display:none here. */
    if (searchOpen()) {
      var openModal = searchModalRoot;
      if (openModal && typeof openModal.close === 'function') {
        searchYield = true;
        openModal.close(false);
      }
    }
    lastFocus = document.activeElement;
    /* The dialog boundary is the whole .fd-bnav, because the tray's close and
       back controls live in the bottom bar beside it — that is also exactly
       what the focus trap below encloses, so the two agree. The role is set on
       open and removed on close: .fd-bnav is always in the DOM (display:none on
       desktop), and a permanent, permanently-shut dialog would be announced to
       assistive tech as a dialog that is simply always there. */
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    tray.hidden = false;
    if (scrim) scrim.hidden = false;
    /* the transform transition needs the element laid out first */
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      /* after the class, not before: activeSlot() reads .is-open to decide
         that the menu slot is the lit one */
      syncIndicator(true);
    });
    toggle.setAttribute('aria-expanded', 'true');
    if (labelOpen) labelOpen.hidden = true;
    if (labelClose) labelClose.hidden = false;
    document.body.classList.add('overflow-hidden');
    showPanel('root');
  }

  function close() {
    root.classList.remove('is-open');
    root.removeAttribute('role');
    root.removeAttribute('aria-modal');
    toggle.setAttribute('aria-expanded', 'false');
    if (labelOpen) labelOpen.hidden = false;
    if (labelClose) labelClose.hidden = true;
    document.body.classList.remove('overflow-hidden');
    showPanel('root');
    lastDrill = null;
    window.setTimeout(function () {
      if (root.classList.contains('is-open')) return;
      tray.hidden = true;
      if (scrim) scrim.hidden = true;
    }, 300);
    /* .is-open came off at the top of this function, so the indicator slides
       back to the page slot -- or fades out where the page has no slot. */
    syncIndicator(true);
    /* document.activeElement is <body> rather than null when nothing was
       focused, so lastFocus needs checking, not just a truthiness test. */
    focusSafely([lastFocus, toggle]);
  }

  /* The single way back out of a sub-tray: the drill row that opened it is the
     most useful landing spot, and it is the place a sighted user's eye is
     already returning to. */
  function backToRoot() {
    showPanel('root');
    focusSafely([lastDrill, toggle]);
    lastDrill = null;
  }

  function isOpen() {
    return root.classList.contains('is-open');
  }

  toggle.addEventListener('click', function () {
    if (isOpen()) close();
    else open();
  });

  if (scrim) scrim.addEventListener('click', close);

  /* A slot that links to the page you are already on (the server marks it
     aria-current, same path test as the lit disc) has nowhere to go: while the
     tray is up, tapping it closes the tray -- the indicator slides home --
     instead of reloading the page underneath. Tray closed, the link keeps its
     native behaviour. The basket slot forwards to the drawer and is left alone. */
  root.querySelectorAll('a.fd-bbar-btn[aria-current="page"]:not([data-fd-cart-slot])').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (!isOpen()) return;
      event.preventDefault();
      close();
    });
  });

  root.querySelectorAll('[data-fd-drill]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      lastDrill = btn;
      showPanel(btn.dataset.fdDrill);
      var scope = '[data-fd-tray="' + btn.dataset.fdDrill + '"]';
      focusSafely([tray.querySelector(scopedFocusable(scope)), backBtn, toggle]);
    });
  });

  if (backBtn) backBtn.addEventListener('click', backToRoot);

  /* ---- keyboard: Escape backs out one level, then closes; Tab is trapped
     across the tray and the bar, which together are the open surface ---- */
  document.addEventListener('keydown', function (event) {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      if (tray.classList.contains('is-drilled')) backToRoot();
      else close();
      return;
    }

    if (event.key !== 'Tab') return;
    var items = Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ---- touch: swipe DOWN on the open sheet closes it (the panel rises from
     the bottom bar, so down is its dismiss direction) -- but ONLY when the
     panel under the finger was already at the top of its own scroll, since
     scrolling a long list back up is the very same finger motion; swipe RIGHT
     in a sub-tray backs out, mirroring the horizontal slide. 60px of travel
     with the dominant axis at least twice the other, so a diagonal flick while
     scrolling the tray never fires either gesture. ---- */
  var startX = 0;
  var startY = 0;
  var live = false;
  /* The panel under the finger, and whether it was already at its top when
     the finger landed. .fd-tray-panel is the scroll container (overflow-y:
     auto, max-height 72vh), so scrolling a long list back UP is the same
     finger motion as a swipe-down dismiss. The dismiss therefore only counts
     when there was nothing left to scroll up to -- the sheet's own "pull it
     down" gesture -- and a list that is mid-scroll can never close the tray
     (user, real-device 2026-09-06). Read at touchstart, not touchend: by the
     end of the scroll the panel IS at the top, which is exactly the case
     that must not fire. */
  var atTop = true;

  tray.addEventListener(
    'touchstart',
    function (event) {
      var t = event.changedTouches[0];
      startX = t.clientX;
      startY = t.clientY;
      live = true;
      var panel = event.target.closest ? event.target.closest('.fd-tray-panel') : null;
      atTop = !panel || panel.scrollTop <= 0;
    },
    { passive: true }
  );

  tray.addEventListener(
    'touchend',
    function (event) {
      if (!live) return;
      live = false;
      var t = event.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (atTop && dy >= 60 && dy >= Math.abs(dx) * 2) {
        close();
      } else if (dx >= 60 && dx >= Math.abs(dy) * 2 && tray.classList.contains('is-drilled')) {
        backToRoot();
      }
    },
    { passive: true }
  );

  /* ---- the sliding indicator ----
     One highlight for the whole pill, placed by measurement rather than by
     class, so it TRAVELS between slots instead of popping. Everything below is
     additive: .fd-bbar-ind ships `hidden` and the legacy per-slot ::before
     discs stay the highlight until .has-ind lands, so JS off -- or any throw
     before the first placement -- leaves the pill exactly as it was. */

  /* Where the highlight belongs, derived every time and never remembered. */
  function activeSlot() {
    if (isOpen()) {
      /* In a sub-tray the Back slot REPLACES the menu slot -- the menu is
         display:none by CSS while the tray is drilled -- so Back is the
         visible slot standing in the same place. Measuring the menu there
         would measure a zero-width box. */
      if (backBtn && !backBtn.hidden) return backBtn;
      return toggle;
    }
    /* The search modal is the pill's other open sheet, and while it is up the
       search slot is showing its X: same statement as the menu slot's, so the
       same highlight. The tray is always closed by then (the tap that opens
       search closes it), so these two branches cannot both claim the light. */
    if (searchSlot && searchOpen()) return searchSlot;
    /* Any drawer trigger counts, not just the pill's own basket slot: the
       class is the drawer's own open state, so Dawn's hidden header link and
       every add-to-basket path light the basket too. With cart_type 'page',
       or a drawer that never upgraded, there is simply no element to watch. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.classList.contains('active') && cartSlot) return cartSlot;
    return root.querySelector('.fd-bbar-btn.is-on');
  }

  function placeIndicator(slot, animate) {
    if (!bar || !ind) return;
    /* Nothing to measure: above 820px .fd-bnav is display:none, so every box
       is zero. Leave the indicator untouched rather than writing a garbage
       position, and leave .has-ind off so the desktop DOM is unchanged. */
    if (!bar.clientWidth) return;
    root.classList.add('has-ind');
    window.clearTimeout(indHide);

    if (!slot || slot.hidden || !slot.offsetWidth) {
      ind.classList.add('is-off');
      /* hidden lands after the fade, the same two-step the tray uses -- and
         only if it is not already set, or the mutation observer below would
         see its own write and re-arm this timer forever. */
      indHide = window.setTimeout(function () {
        if (ind.classList.contains('is-off') && !ind.hidden) ind.hidden = true;
      }, 200);
      return;
    }

    /* .fd-bbar is position:fixed, so it is the offset parent and these are
       already pill-relative. The indicator is always the 44px disc: both edges
       are padded in by half the slot's spare width so it lands centred. */
    var hit = parseFloat(getComputedStyle(bar).getPropertyValue('--fd-slot-hit')) || 44;
    var pad = (slot.offsetWidth - hit) / 2;
    var l = slot.offsetLeft + pad;
    var r = bar.clientWidth - (slot.offsetLeft + slot.offsetWidth) + pad;
    var prev = parseFloat(ind.style.getPropertyValue('--fd-ind-l'));
    /* A hidden indicator has no position worth travelling from: it FADES in
       where it is needed rather than flying across the pill from wherever it
       was left. Same branch covers first paint. */
    var wasHidden = ind.hidden || ind.classList.contains('is-off');
    /* A re-measure that lands on the SAME target has nothing to do -- and must
       not touch the element: stamping transition:none on a slide already in
       flight towards that target (resize from the iOS URL bar, a section
       re-render) would cut it short exactly like the observer bug did. */
    if (!animate && !wasHidden && prev === l &&
        parseFloat(ind.style.getPropertyValue('--fd-ind-r')) === r) return;

    ind.dataset.dir = isNaN(prev) || l >= prev ? 'r' : 'l';
    if (!animate || wasHidden) ind.style.transition = 'none';
    ind.hidden = false;
    ind.style.setProperty('--fd-ind-l', l + 'px');
    ind.style.setProperty('--fd-ind-r', r + 'px');
    if (!animate || wasHidden) {
      void ind.offsetWidth; /* commit the jump before transitions come back */
      ind.style.transition = '';
    }
    ind.classList.remove('is-off');
  }

  function syncIndicator(animate) {
    placeIndicator(activeSlot(), animate);
  }

  if (bar && ind) {
    /* the drawer's open state, whatever opened it */
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      new MutationObserver(function () {
        syncIndicator(true);
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    /* Back and Add slots ship hidden and are un-hidden by the tray and by
       fd-buy-bar.js respectively; either changes every slot's width. Only SLOT
       flips count: the indicator's own hidden flips would make this observe
       itself, and the toggle's two visually-hidden label spans flip `hidden`
       inside open()/close() -- reacting to those ran a no-animate re-measure
       as a microtask right after close() had started the slide home, and the
       transition:none it stamps cancelled the slide (real-device snap,
       2026-09-05). Slot widths only change when a slot itself is hidden -- and
       actually CHANGES: showPanel('root') re-writes the Back slot's hidden=true
       on every open/close, and a same-value write still yields a record, so a
       flip that left the state as it was is ignored too. */
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t === ind || !t.classList || !t.classList.contains('fd-bbar-btn')) continue;
        if ((records[i].oldValue !== null) === t.hidden) continue; /* no real change */
        syncIndicator(false);
        return;
      }
    }).observe(bar, { attributes: true, attributeFilter: ['hidden'], attributeOldValue: true, subtree: true });

    /* The PILL's own width is no longer the row's width: since treatment B the
       Add segment is its SIBLING inside .fd-dock, so the pill narrows the
       moment fd-buy-bar.js unhides the segment on a PDP -- and every slot's
       offsetLeft moves with it. The hidden-attribute observer below cannot see
       that: the segment is outside .fd-bbar and is not a .fd-bbar-btn. Watching
       the pill's own box is cause-agnostic and catches the upgrade whichever
       order the two scripts happen to run in.

       Re-measure only, never animate -- exactly what the window resize handler
       does, and placeIndicator()'s same-target guard makes a no-change callback
       a no-op, so it cannot cut a slide short. */
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        syncIndicator(false);
      }).observe(bar);
    }

    var resizePending = false;
    window.addEventListener('resize', function () {
      if (resizePending) return;
      resizePending = true;
      requestAnimationFrame(function () {
        resizePending = false;
        syncIndicator(false);
      });
    });

    /* Another section re-rendering can move the pill's neighbours around. A
       header load replaces this whole root, and the fresh copy places its own
       indicator, so stale listeners left over from a replaced root stand down. */
    document.addEventListener('shopify:section:load', function (event) {
      if (!root.isConnected) return;
      if (event.target.contains(root)) return;
      syncIndicator(false);
    });

    /* First paint: place it, never animate it. rAF so the pill has been laid
       out (and its fonts settled) before anything is measured. */
    requestAnimationFrame(function () {
      syncIndicator(false);
    });
  }

  /* ---- theme editor: selecting a bottom-bar block opens the tray so the
     merchant can see what they are editing ---- */
  document.addEventListener('shopify:block:select', function (event) {
    if (!root.contains(event.target)) return;
    if (!isOpen()) open();
  });
})();
